const __filename = "/app/components/cms/blocks/video_gallery/ns.js", __dirname = "/app/components/cms/blocks/video_gallery";
import WebComponent from '@rubygems/hue/app/components/web_component'

// Upgrades ns.rb's facade into the click-to-play dialog live draws — see ns.rb for why the
// picture is a link until this runs, and why the frame carries `data-src` rather than `src`.
//
// Two things the markup cannot do on its own: open the dialog, and move `data-src` across at that
// moment so nothing is fetched before someone presses play. Everything else — the focus trap, the
// backdrop, Escape, `aria-modal` — is `dialog`'s own.
WebComponent.register(
  class extends WebComponent {
    // Matches `extend Hue::Phlex::CustomElement(:video_gallery)` — `buildName` would derive
    // `components-cms-blocks-video-gallery-ns` from the filename instead.
    static componentName = 'video-gallery'

    connectedCallback() {
      super.connectedCallback()
      this.upgrade()
    }

    upgrade() {
      this.querySelectorAll('[data-video-open]').forEach(trigger => {
        // The dialog is the facade's next sibling. A trigger without one keeps its href and stays
        // an ordinary link to the video, which is the same thing it was before this ran.
        const dialog = trigger.nextElementSibling
        if (dialog?.tagName !== 'DIALOG') return

        // It is a button now, not a link: it opens something on this page rather than going
        // anywhere, and a reader hearing "link" would be told the wrong thing.
        trigger.setAttribute('role', 'button')
        trigger.addEventListener('click', event => {
          event.preventDefault()
          this.open(dialog)
        })
        // Closing stops the video. Clearing `src` is what does it — `dialog.close()` only hides
        // the element, and a hidden YouTube frame carries on playing its audio.
        dialog.addEventListener('close', () => this.stop(dialog))
      })
    }

    open(dialog) {
      const frame = dialog.querySelector('iframe')
      if (frame && !frame.src) frame.src = frame.dataset.src
      dialog.showModal()
    }

    stop(dialog) {
      const frame = dialog.querySelector('iframe')
      if (frame) frame.removeAttribute('src')
    }
  }
)
